
import axios from 'axios';
import { UserContext } from '../../../Contexts/UserContext';
import useModule from '../../../hooks/useModule';
import { React, useState, useContext, useEffect } from 'react'
import {useParams } from 'react-router-dom';
import TF_US from '../../../images/Shape_4/png/Shape.png';
import TF_INR from '../../../images/noun-investment-2180740_2/png/noun-investment-2180740.png';
import Company from '../../../images/noun-investment-2180740_5/png/noun-investment-2180740.png';
import { retopCardUrl } from '../../../Config/config';
import Image from "../../../images/Combined Shape_3/png/Combined Shape.png"
import OverflowToolTip from '../../shared/OverflowToolTip';


const Card = () => { 

  const [detailCard, setDetailCard] = useState();
  const { companyId } = useParams();
  let companyProfileId = parseInt(companyId)
  const {getToken} = useContext(UserContext);
  const [isLoading, setisLoading] = useState(false);
  const { primaryMasterId } = useModule()

 
/**
 * The function `getCardDetails` makes a POST request to a specified URL with the company ID and type
 * as parameters, and sets the response data as the value of `DetailCard` if the response status is
 * 200.
 */
  const getCardDetails = () => {
    setisLoading(true);
    axios.post(retopCardUrl, {
      "company_id": companyProfileId,
      "type": primaryMasterId
    }, {
      headers: {
        "Authorization": getToken()
      }
    }).then(response => {
      setisLoading(false);
      if(response.status===200){
        setDetailCard(response.data?.data)
        
      }
    }).catch(error => {
      setisLoading(false);
    })
  }

  useEffect(() => {
    getCardDetails();
  }, [companyProfileId])
  


  return (
 
    <div className="bg-[#EDEDED]">

      <div className='sm:full mt-[4.25rem] md:mt-[3rem] h-full  bg-[#F2F2F2]'>
        {/* <div> */}
           <div className="overflow-x-auto lg:grid grid-cols-5 gap-4  px-4 py-[0.7rem] flex xl:overflow-hidden">
              {/* ----card1----- */}
          <section className="flex-shrink-0 ">
            <div className="bg-white px-3 py-1  rounded-md  border border-gray-200 overflow-hidden card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className=" text-[12pt] leading-[16pt] tracking-[-0.3pt] lg:text-[13px] lg:leading-[16px] font-sans_book_body text-[#2B2A29] lg:tracking-[-0.3px] "> Total Funding  </div>
                  {!isLoading ?
                    detailCard?.total_funding!=null && detailCard?.total_funding!=0 && detailCard?.total_funding !='$ 0 M' && detailCard?.total_funding !='--'?
                    <div className="flex space-x-1 flex items-center">
                    <div className="  text-[#A5711A] ">
                      <span
                        className='text-[16pt] leading-[16pt]  font-bold lg:text-[17px] lg:leading-[19px] text-[#A5711A] '>$ </span>
                      <span
                        className='text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A] '>
                            {detailCard?.total_funding??"--"}

                        </span>
                      {/* {/* <span className=' font-semibold text-md text-[#A5711A] '>/</span> */}
                      {/* <span
                        className='font-semibold  text-[18px] text-[#A5711A] '>87</span> */}
                      <span
                        className='text-[16pt] leading-[16pt]  font-bold text-[#A5711A] lg:text-[17px] lg:leading-[22px] '> M</span>
                    </div>
                  </div>
                   : <div className="text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]">--</div>
                   :
                   <div className="w-full bg-[#FFFFFF]">
                     <div role="status" className="bg-white">
                       <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                         <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                       </svg>
                     </div>
                   </div>
                 }
                </div>

                <div className="flex-shrink-0 flex justify-center items-center  pl-5">
                  <a>
                    <img className="h-[22px] max-w-[25px] " fill="currentColor"
                      src={Image} />
                  </a>
                </div>
              </div>
            </div>
          </section>
          {/* ----card2----- */}
          <section className="flex-shrink-0">
            <div className=" bg-white px-3 py-1  rounded-md  border border-gray-200 overflow-hidden card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4">
                  <div className="text-[13pt]  leading-[16pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body  text-[#2B2A29] tracking-[-0.3px]">Projects </div>
                  {!isLoading ?
                    detailCard?.no_of_projects!=null && detailCard?.no_of_projects!=0 ?
                  <div className="flex space-x-1">
                    <div className="  text-[#A5711A] ">
                      <span
                        className='text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  '>
                          {detailCard?.no_of_projects??"--"}
                        </span>

                    </div>
                  </div>
                   : <div className="text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]">--</div>
                   :
                   <div className="w-full bg-[#FFFFFF]">
                     <div role="status" className="bg-white">
                       <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                         <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                       </svg>
                     </div>
                   </div>
                 }
                </div>
                
                  <div className="flex-shrink-0 flex justify-center items-center  pl-5">
                    <a>
                      <img className="h-[23px] max-w-[25px] "
                        src={TF_US} />
                    </a>
                  </div>
               
              </div>
            </div>
          </section>
          {/* ----card3----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3 py-1  rounded-md  border border-gray-200 overflow-hidden card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className="text-[13pt]  leading-[16pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body  text-[#2B2A29] tracking-[-0.3px]">Latest Project</div>
                  {!isLoading ?
                    detailCard?.latest_project!=null && detailCard?.latest_project!=0 ?
                  <div className="flex space-x-1 ">
                    <div className="  ">
                      <span
                        className='text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  '>
                         <OverflowToolTip isTopCard={true} className="max-w-[10rem] 2xl:max-w-[14.5rem]" component ={ detailCard?.latest_project??"--"} />
                        </span>
                    </div>
                  </div>
                   : <div className="text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]">--</div>
                   :
                   <div className="w-full bg-[#FFFFFF]">
                     <div role="status" className="bg-white">
                       <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                         <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                       </svg>
                     </div>
                   </div>
                 }
                </div>

                <div className="flex-shrink-0  flex justify-center items-center pl-5">
                  <a >
                    <img className="h-[25px] max-w-[25px]"
                      src={TF_INR} />
                  </a>
                </div>
              </div>
            </div>
          </section>
          {/* ----card4----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3 py-1  rounded-md  border border-gray-200 overflow-hidden card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className=" text-[13pt]  leading-[16pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body  text-[#2B2A29] tracking-[-0.3px]">Investors </div>
                  {!isLoading ?
                    detailCard?.no_of_investors!=null && detailCard?.no_of_investors!=0 ?
                  <div className="flex space-x-1 ">
                    <div className="  ">
                      <span
                        className='text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A] '>
                          {detailCard?.no_of_investors??"--"}
                        </span>
                    </div>
                  </div>
                   : <div className="text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]">--</div>
                   :
                   <div className="w-full bg-[#FFFFFF]">
                     <div role="status" className="bg-white">
                       <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                         <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                       </svg>
                     </div>
                   </div>
                 }
                </div>
                <div className="flex-shrink-0 flex justify-center items-center pl-5">
                  <a >
                    <img className="h-[26px] max-w-[25px] "
                      src={Company} />
                  </a>
                </div>
              
            </div>
            </div>            
          </section>
          {/* ----card5----- */}
        
          <section className="flex-shrink-0 ">
            <div className="bg-white px-3 py-1  rounded-md  border border-gray-200 overflow-hidden card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className=" text-[13pt]  leading-[17pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body  text-[#2B2A29] tracking-[-0.3px] "> Total Exits</div>
                  {!isLoading ?
                    detailCard?.total_exits!=null && detailCard?.total_exits!=0 && detailCard?.total_exits !='$ 0 M' && detailCard?.total_exits != '--'?
                  <div className="flex space-x-1 ">
                    <div className="  text-[#A5711A] ">
                      <span
                        className='text-[16pt] leading-[16pt]  font-bold lg:text-[17px] lg:leading-[19px] text-[#A5711A] '>$ </span>
                      <span
                        className='text-[16pt] leading-[16pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]   '>
                            {detailCard?.total_exits??"--"}

                        </span>
                      {/* {/* <span className=' font-semibold text-md text-[#A5711A] '>/</span> */}
                      {/* <span
                        className='font-semibold  text-[18px] text-[#A5711A] '>87</span> */}
                      <span
                        className='text-[16pt] leading-[16pt]  font-bold text-[#A5711A] lg:text-[17px] lg:leading-[22px] '> M</span>
                    </div>
                  </div>
                   : <div className="text-[16pt] leading-[20pt] font-bold  whitespace-nowrap lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]">--</div>
                   :
                   <div className="w-full bg-[#FFFFFF]">
                     <div role="status" className="bg-white">
                       <svg className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                         <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                       </svg>
                     </div>
                   </div>
                 }
                </div>

                <div className="flex-shrink-0 flex justify-center items-center  pl-5">
                  <a>
                    <img className="h-[22px] max-w-[25px] " fill="currentColor"
                      src={Image} />
                  </a>
                </div>
              </div>
            </div>
          </section>

        </div>

        <div className='border-b-2 border-[#e5e5e5]'></div>

      </div >
    </div >


  )
}

export default Card;